import InputSigarusText from '../InputSigarusText'
import InputSigarusTextarea from '../InputSigarusTextarea'
import InputSigarusTimePicker from '../InputSigarusTimePicker'
import InputSigarusDatePicker from '../InputSigarusDatePicker'
import InputSigarusCheckbox from '../InputSigarusCheckbox'
import InputSigarusHidden from '../InputSigarusHidden'
import numberVariations from './numberVariations'
import selectVariations from './selectVariations'
import inputExtend from './inputExtend'


/*
TEST HOOKS
const textprueba = inputExtend(InputSigarusText, [{
	hook: 'input',
	callback: function (comp, val) {
		return val + ' prueba test'
	}
}], {});
*/

const inputs = {
	textarea: InputSigarusTextarea,
	checkbox: InputSigarusCheckbox,
	text: InputSigarusText,
	timepicker: InputSigarusTimePicker,
	datepicker: InputSigarusDatePicker,
	hidden: InputSigarusHidden,
	...numberVariations,
	...selectVariations
}

export default Object.keys(inputs).reduce((o, k) => {

	const iName = `l-${k}`

	o[iName] = inputs[k]

	if (!o[iName].methods) o[iName].methods = {}

	return o

}, {})
